import { loadStripe } from '@stripe/stripe-js';
import API_URL from './api';

let stripePromise = null;
let publishableKeyCache = null;

export async function getStripePublishableKey(token) {
  if (publishableKeyCache) {
    return publishableKeyCache;
  }

  if (token) {
    try {
      const response = await fetch(`${API_URL}/stripe/config`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.ok) {
        const data = await response.json();
        if (data.publishableKey) {
          publishableKeyCache = data.publishableKey;
          return publishableKeyCache;
        }
      }
    } catch (err) {
      console.error('Failed to load Stripe config:', err);
    }
  }

  const envKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
  if (envKey) {
    publishableKeyCache = envKey;
    return envKey;
  }

  return null;
}

export async function getStripe(token) {
  const key = await getStripePublishableKey(token);
  if (!key) {
    return null;
  }

  if (!stripePromise) {
    stripePromise = loadStripe(key);
  }

  return stripePromise;
}

export function resetStripeCache() {
  stripePromise = null;
  publishableKeyCache = null;
}
